/** Coerces a data-bound value (typically a string) to a boolean. */
export function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false';
}
//# sourceMappingURL=boolean-property.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/core/coercion/boolean-property.js
// module id = 187
// module chunks = 3